export enum DownPaymentMode {
    Percent = "Percent",
    PerTeam = "PerTeam"
}
